import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {map} from 'rxjs/operators';

const routers = {
  verify: '/document-verify/verify'
};

@Injectable({
  providedIn: 'root'
})
export class VerifyDocumentService {

  constructor(
    private apiService: ApiService
  ) {
  }

  documentVerify(file: File) {
    /// contract/upload/file/
    const formData = new FormData();
    formData.append('file', file);
    return this.apiService.postUpload(routers.verify, formData)
      .pipe(map(res => {
        return res;
      }));
  }
}
